import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavMenuItems } from '../Models/NavMenuItems';
import { UsersService } from '../Services/users.service';
declare const NaveStartup: any;
import { catchError, retry, map } from 'rxjs/operators';
import { interval, Subscription, timer } from 'rxjs';
import { AgencyBranchCreditProperties, AgencyMasterProperties, BackSystemCreditLimitProperties, BackSystemCreditRequest, ManagerDetailsProperties, ReportTypesUser, } from '../Models/AgencyMasterProperties';
import { AgencyService } from '../Services/Agency.service';
import { CMSService } from '../Services/cms.service';

import { GetAllCmsLoginProperties, CmsLogoProperties } from '../Models/CmsLoginHeaderProperties';
import { ReportAgencyRightsProperties, ReportUserRightsProperties } from '../Models/AgencyRightsProperties';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { AuthService } from '../Services/auth.service';
import { BranchService } from '../Services/branch.service';
import { BranchInformationProperties } from '../Models/BranchInformationProperties';
import { ChatAppMessageProperties } from '../Models/ChatAppProperties';
import { OfflineNewVersionService } from '../Services/offline-newVersion.service';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { OfflineNewVersionProperties } from '../offline-new/offlineNewProperties';
import { isUndefined } from 'util';
import { InsuranceTypesSwitchProps } from '../Models/TravelInsuranceProperties';
import { LoginUserProperties } from '../Models/UsersProperties';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  userid: string = "";
  navMenue = new NavMenuItems();
  creditData: AgencyBranchCreditProperties;
  creditLimit: number = 0;
  loginAgency: string = "";
  managerDetails: ManagerDetailsProperties;
  timerSubscription: Subscription;
  agencyOnline: AgencyMasterProperties;
  reportRights: ReportUserRightsProperties[] = [];
  branchOnline: BranchInformationProperties;

  backSystemCompanies: CompanyMasterProperties[] = [];
  backSystemCompanyId: number;
  backSystemCompanyCustomer: string;
  backSystemCreditRequest = new BackSystemCreditRequest();
  backSystemCreditLimit = new BackSystemCreditLimitProperties();
  operatingCountry = environment.operatingCountry;
  ImmediateParent: string = "";
  userName: string = "";
  agencyNumber: string = "";
  private beepSound: HTMLAudioElement;
  private notificationSubscription!: Subscription;
  constructor(private branchService: BranchService, private authservice: AuthService, private logout: NgbModal, private managerModel: NgbModal, private router: Router, private userService: UsersService, private agencyService: AgencyService, private cmsService: CMSService, private service: OfflineNewVersionService, private updatePasswordModel: NgbModal, private messageService: MessageService) { this.beepSound = new Audio('assets/mix.wav'); }
  insuranceOption: InsuranceTypesSwitchProps[] = [];
  getInsuranceOption() {
    this.cmsService.GetInsuranceTypesStatus().subscribe(data => {
      this.insuranceOption = data;
    });
  }
  ngOnInit() {
    this.getInsuranceOption();
    let mutechat = (localStorage.getItem("MuteChatOffline"));
    if (mutechat == null || mutechat == undefined) {
      localStorage.setItem("MuteChatOffline", "false");
      this.mutestring = "Mute";
    }
    if (mutechat == "true") {
      this.mutestring = "Muted";
    }


    this.userName = (localStorage.getItem('fullName'));
    this.userid = (localStorage.getItem('UserId'));
    this.getLogo();
    if (this.userid == undefined || this.userid == null || this.userid == "") {
      localStorage.clear();
      this.router.navigateByUrl('/');
    }
    else {
      this.notificationSubscription = interval(200000).subscribe(() => {
        this.getNotificationList();
      });
      this.userService.GetUsersNavMenu(localStorage.getItem('AgencyId'), localStorage.getItem('UserId')).subscribe((data) => {
        //////console.log (data);
        this.navMenue = data;
        localStorage.setItem("InsuranceRights", JSON.stringify({ "issue": this.navMenue.insuranceIssuanceRight, "view": this.navMenue.insuranceBookedViewRight, "cancel": this.navMenue.insuranceCancelRight }));
        this.reportRights = data.reportUserRights;

      });
      this.getManagerDetails();
      this.getAgency();
      //this.timerSubscription = timer(0, 300000).pipe(
      //  map(() => {

      //    // this.getPendingCredit(); // load data contains the http request


      //  })
      //).subscribe();
    }

    this.GetBackSystemCompanies();
   


  }
  ngOnDestroy() {
    if (this.notificationSubscription) {
      ////console.log ("unsub")

      this.notificationSubscription.unsubscribe(); // Unsubscribe to prevent memory leaks
    }
  }
  mutestring: string = "Mute";
  mutechat() {
    let mutechat = localStorage.getItem("MuteChatOffline");
    if (mutechat == null || mutechat == undefined) {
      localStorage.setItem("MuteChatOffline", "false");
      this.mutestring = "Mute";
    }
    if (mutechat == "true") {
      localStorage.setItem("MuteChatOffline", "false");
      this.mutestring = "Mute";
    }
    else {
      localStorage.setItem("MuteChatOffline", "true");
      this.mutestring = "Muted";
    }

  }
  GetBackSystemCompanies() {
    this.agencyService.GetCompanyMaster().subscribe(data => {
      this.backSystemCompanies = data;
    });
  }
  GetLoginBackSystemCredit = (): void => {
    this.creditLimitloader = true;
    this.backSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
    this.backSystemCompanyCustomer = localStorage.getItem("BackSystemCompanyCustomer");
    this.ImmediateParent = localStorage.getItem("ImmediateParent");
    if (this.ImmediateParent == "AG01") {
      if ((this.backSystemCompanyId != undefined && this.backSystemCompanyId != null && this.backSystemCompanyId > 0)
        && (this.backSystemCompanyCustomer != undefined && this.backSystemCompanyCustomer != null && this.backSystemCompanyCustomer != "")) {
        if (this.backSystemCompanies && this.backSystemCompanies.length > 0) {

          for (let i = 0; i < this.backSystemCompanies.length; i++) {
            if (this.backSystemCompanyId == this.backSystemCompanies[i].companyId) {
              this.backSystemCreditRequest.companyURL = this.backSystemCompanies[i].companyURL;
              this.backSystemCreditRequest.companyCustomer = this.backSystemCompanyCustomer;
              this.agencyService.GetBackSystemCredit(this.backSystemCreditRequest).subscribe(data => {
                //   ////console.log (data)
                if (data != null) {

                  this.backSystemCreditLimit = data;
                  this.creditLimitloader = false;
                  this.creditLimitShow = true;
                  // this.backSystemCreditLimit.creditLimit = this.backSystemCreditLimit.creditLimit - this.backSystemCreditLimit.creditOutstanding;
                }
                else {
                  this.getPendingCredit()
                }

              })
              break;
            }
          }
        }

      }
    }
    else {
      this.getPendingCredit();
    }

  }

  creditLimitloader: boolean = false;
  creditLimitShow: boolean = false;
  closecreditlimit() {
    this.creditLimitShow = false;
  }
  getPendingCredit = (): void => {

    let agencyID = localStorage.getItem('AgencyId');
    let branchID = localStorage.getItem("BranchId");
    this.agencyService.GetAgencyBranchPendingCreditS(agencyID).subscribe((data) => {
      this.creditData = data;
      if (this.creditData.agencyMasterProp.length > 0)
        this.backSystemCreditLimit.creditLimit = this.creditData.agencyMasterProp[0].pendingcreditLimit;
      else
        this.backSystemCreditLimit.creditLimit = this.creditData.branchInfoProp[0].pendingcreditLimit;

    })
  }

  logo = '';
  getLogo() {

    try {

      let agencyId = localStorage.getItem("AgencyId");
      //let branchId = localStorage.getItem("BranchId");
      this.agencyNumber = agencyId;

      if (agencyId.includes('B')) {
        this.branchService.GetBranchById(agencyId).subscribe((data) => {

          this.branchOnline = data;
          //this.reportRights = data.agencyRightObj.reportRights;


          this.logo = this.branchOnline.imageFile;

          this.logo = `data:image/png;base64,${this.logo}`;

        });
      }

      else {
        this.agencyService.GetAgencyById(agencyId).subscribe((data) => {

          this.agencyOnline = data;
          //this.reportRights = data.agencyRightObj.reportRights;


          this.logo = this.agencyOnline.imageFile;

          this.logo = `data:image/png;base64,${this.logo}`;

        });
      }



    } catch (e) { }

  }




  ///////////////////////////////////////////////////////////


  //login Agency
  getAgency() {
    let agencyID = localStorage.getItem("AgencyId");
    let branchID = localStorage.getItem("BranchId");
    if (agencyID) {
      this.loginAgency = agencyID;
    }
    if (branchID) {
      this.loginAgency = branchID;
    }
  }

  /////////////////////////////////////////////////////////////////////////////
  ManagerDetails(TargetModel) {
    this.managerModel.open(TargetModel, {
      size: 'sm'
    })
    //document.querySelector(".manager-window").classList.remove("manager-hidden");

  }

  //ManagerDetails() {
  //  document.querySelector(".manager-window").classList.remove("manager-hidden");

  //}
  ManagerClosed() {
    document.querySelector(".manager-window").classList.add("manager-hidden")
  }
  getManagerDetails() {
    this.agencyService.GetManagerByAgencyIdS(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.managerDetails = data;
      ////////console.log (this.managerDetails);
    })
  }


  logoutlinkClicked(targetmodel) {
    this.logout.open(targetmodel, {
      windowClass: "warningmodal"
    })
    //document.querySelector(".design-logout").classList.remove("hidden-log");
  }
  updatePasswordLinkClicked(targetmodel) {
    const modalRef = this.updatePasswordModel.open(targetmodel, { windowClass: "warningmodal" });

    modalRef.result.then((result) => {
      if (result === 'update') {
        this.onUpdatePasswordClick(targetmodel);
      }
    }).catch(() => { });
  }

  newPassword: string;
  currentPassword: string;
  onUpdatePasswordClick(modal: any) {
    let userObj = new LoginUserProperties();
    userObj.userId = Number(localStorage.getItem("UserId"));
    userObj.oldPassword = this.currentPassword;
    userObj.password = this.newPassword;
    this.userService.updatePassword(userObj).subscribe(data => {
      if (data) {
        // ✅ Success
        modal.close(); // hide modal
        this.messageService.add({ severity: 'success', summary: 'Password updated successfully!', detail: "" });
       // alert("Password updated successfully!");
       // this.toastr.success("Password updated successfully!");
        this.currentPassword = '';
        this.newPassword = '';
      } else {
        // ❌ Failure (invalid old password)
       // alert("Invalid old password. Please try again.");
        this.messageService.add({ severity: 'error', summary: 'Invalid old password.', detail: ' Please try again!' });
      }
    });
  }
  cancelClicked() {
    //document.querySelector(".design-logout").classList.add("hidden-log");
  }
  yeslogout() {
    this.logout.dismissAll();
    window.localStorage.setItem('logout-event', Math.random().toString())
    this.authservice.logOut();
  }
  groupedMessages: Record<string, ChatAppMessageProperties[]>;
  objectKeys = Object.keys;
  messages: ChatAppMessageProperties[] = [];
  noMessagefound: boolean = false;
  isDropdownOpen: boolean = false;
  isShaking: boolean = false;
  faClose = faClose;
  getNotificationList() {
    try {
      let userid = localStorage.getItem("UserId");
      if (userid != null && userid != "" && userid!= undefined) {
        this.service.GetNotificationList(userid).subscribe((data) => {
          if (data) {
            if (data.length == 0) {
              this.noMessagefound = true;
              this.messages = [];
              this.groupedMessages = this.groupByUniqueId(this.messages);
              return;
            }
            else {
              if (JSON.stringify(this.messages) !== JSON.stringify(data)) {
                this.messages = data;
                let mutechat = (localStorage.getItem("MuteChatOffline"));
                if (mutechat == null || mutechat == undefined) {
                  localStorage.setItem("MuteChatOffline", "false");
                  mutechat = "false";
                }
                if (mutechat == "false") {
                  this.beepSound.play();
                }
                this.isShaking = true;
                setTimeout(() => {
                  this.isShaking = false;
                }, 6000);

                // Update grouped messages
                this.groupedMessages = this.groupByUniqueId(this.messages);
                this.noMessagefound = false;
              }

            }

          }
        });

      }
    }
    catch (e) {

    }
  }
  messagetochat(uniqueId) {
    let offline = new OfflineNewVersionProperties();
    offline.offlineId = Number(uniqueId);
    offline.assignedUser = Number(localStorage.getItem("UserId"));
    this.service.ChecktheManagerOrNot(offline).subscribe((data) => {
      if (data.success) {

        if (data.type == "User") {
          localStorage.setItem('RequestActionOffline', 'User');
        }
        else if (data.type == "Agent") {
          localStorage.setItem('RequestActionOffline', 'Agent');
          localStorage.setItem("offlineBookingCurnStatus", data.offlineObj.currentBookingStatus.toString());
        }
        localStorage.setItem('RequestActionOffline', 'Agent');
        localStorage.setItem('RequestTypeOffline', 'Update');
        localStorage.setItem("offlineBookingId",data.offlineObj.offlineId.toString());
        localStorage.setItem("requestingAgency",data.offlineObj.requestingAgency);
        localStorage.setItem('fromOfflineRequestRoute', 'managerOfflineRequestList');
        if (data.offlineObj.offlineRequestTypeName.includes("Offline Booking")) {
          this.router.navigateByUrl('/offlineBooking');
        }
        else if (data.offlineObj.offlineRequestTypeName == "Offline Ticket Request") {
          this.router.navigateByUrl('/offlineTicket');
        }
        else if (data.offlineObj.offlineRequestTypeName == "Offline Refund Request") {
          this.router.navigateByUrl('/offlineRefund');
        }
        else if (data.offlineObj.offlineRequestTypeName == "Offline Void Request") {
          this.router.navigateByUrl('/offlineVoid');
        }
        else if (data.offlineObj.offlineRequestTypeName == "Offline Reissue Request") {
          this.router.navigateByUrl('/offlineReissue');
        }

      }
      else {

      }

    });
  }
  groupByUniqueId(messages: ChatAppMessageProperties[]): Record<string, ChatAppMessageProperties[]> {
    return messages.reduce((acc, message) => {
      if (!acc[message.uniqueId]) {
        acc[message.uniqueId] = [];
      }
      acc[message.uniqueId].push(message);
      return acc;
    }, {} as Record<string, ChatAppMessageProperties[]>);
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}
